/**
 * Exports radio button group-related design tokens
 */

export const defaultColumnGap = 'small';
export const defaultRowGap = 'xsmall';